import { FunctionComponent, SVGProps } from 'react'

import PaloAltoLogoFull from '@/assets/org-logos/palo-alto-full.svg'
import PaloAltoLogoIcon from '@/assets/org-logos/palo-alto-icon.svg'
import PwcLogoFull from '@/assets/org-logos/pwc-full.svg'
import PwcLogoIcon from '@/assets/org-logos/pwc-icon.svg'

export type LogoKey = 'palo-alto' | 'pwc'

// Type for logo components - they are SVG components that may accept standard SVG props
export type LogoComponent = FunctionComponent<SVGProps<SVGSVGElement>>

export type LogoSize = { width: number; height: number }

export type LogoVariantMap = {
  full: LogoComponent
  icon: LogoComponent
  /** Render size overrides; each falls back to the default wordmark sizing. */
  fullSize?: LogoSize
  iconSize?: LogoSize
}

export const logoKeyToLogo: Record<LogoKey, LogoVariantMap> = {
  'palo-alto': {
    full: PaloAltoLogoFull,
    icon: PaloAltoLogoIcon,
    fullSize: { width: 84, height: 22 },
    iconSize: { width: 28, height: 21 },
  },
  pwc: { full: PwcLogoFull, icon: PwcLogoIcon },
}
